import React, { Component } from 'react'
import SingleFileUploadModal from './SingleFileUploadModal'
import IconSVG from "../../../utilities/FrontFunctions/IconSVG"
import { isImage, fileReader} from '../../../utilities/FrontFunctions/AoxGlobalFrontFunctions'
import { megabytesToBytes, bytesToMegabytes } from '../../../utilities/FrontFunctions/AoxFrontFunctions'

class MultipleFileUpload extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isHover: false,
			isLoading: false,

			// Liste des items uploadés
			items: [], // { id, file, thumb, name, size, type }

			// erreurs globales
			sizeError: false,
			sizeErrorText: this.props.sizeErrorText ? this.props.sizeErrorText : 'La taille du fichier dépasse la limite autorisée de ',
			formatError: false,
			formatErrorText: this.props.formatErrorText ? this.props.formatErrorText : 'Seuls les formats .jpg, .png et .gif sont autorisés.',
			loadingError: false,
			loadingErrorText: this.props.loadingErrorText ? this.props.loadingErrorText : 'Une erreur s\'est produite...',
			labelText: this.props.labelText ? this.props.labelText : 'Choisir un fichier',
			ctaCancelText: this.props.ctaCancelText ? this.props.ctaCancelText : 'Annuler',

			acceptedFormatsText: this.props.acceptedFormatsText
				? this.props.acceptedFormatsText
				: 'Formats acceptés : jpeg, png, pdf, excel, csv.',

			defaultThumb: this.props.defaultThumb
				? this.props.defaultThumb
				: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDIzIDI4IiBmaWxsPSJub25lIj48cGF0aCBkPSJNMjIuODE1IDkuNTkzIDEzLjIyMSAwaC0yLjA3NHYxMi40NDRoMTEuNjY3eiIgZmlsbD0iIzk4OTg5OCIvPjxwYXRoIGQ9Ik0xMy40NzMuMjUxQTIgMiAwIDAgMCAxMi40NDQgMnY2LjM3YTIgMiAwIDAgMCAyIDJoNi4zN2MuNzUzIDAgMS40MDctLjQxNSAxLjc0OS0xLjAzbC4yNTIuMjUzVjI1YTMgMyAwIDAgMS0zIDNIM2EzIDMgMCAwIDEtMy0zVjNhMyAzIDAgMCAxIDMtM2gxMC4yMjJ6IiBmaWxsPSIjZGFkYWRhIi8+PC9zdmc+',

			thumbSizeH: this.props.thumbSizeH ? this.props.thumbSizeH : 28,
			thumbSizeW: this.props.thumbSizeW ? this.props.thumbSizeW : 23,
			maxSize: this.props.maxSize ? this.props.maxSize : megabytesToBytes(20),

			// ✅ jpeg, png, pdf, excel (xls/xlsx), csv
			formatTypes: this.props.formatTypes
				? this.props.formatTypes
				: [
						'image/jpeg',
						'image/png',
						'application/pdf',
						'application/vnd.ms-excel', // .xls
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
						'text/csv'
				  ],

			timeOutSimulation: this.props.timeOutSimulation ? this.props.timeOutSimulation : false,

			// preview modal
			previewThumb: undefined,
			previewThumbName: undefined
		}

		this.inputRef = React.createRef()

		this.handleFileChange = this.handleFileChange.bind(this)
		this.handleRemoveItem = this.handleRemoveItem.bind(this)
		this.destroy = this.destroy.bind(this)
		this.openPreview = this.openPreview.bind(this)

		this.handleMouseEnter = this.handleMouseEnter.bind(this)
		this.handleMouseLeave = this.handleMouseLeave.bind(this)
	}

	componentDidMount() {
		this.props.onRef(this)
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleMouseEnter() {
		this.setState({ isHover: true })
	}
	handleMouseLeave() {
		this.setState({ isHover: false })
	}

	async handleFileChange(e, fieldName, setFieldValue) {
		const files = Array.from(e.currentTarget.files || [])
		if (files.length === 0) return

		this.setState(
			{
				isLoading: true,
				sizeError: false,
				formatError: false,
				loadingError: false
			},
			() => this.props.onUnload()
		)

		try {
			const prepared = []

			for (const f of files) {
				if (!this.state.formatTypes.includes(f.type)) {
					this.setState({ formatError: true })
					continue
				}
				if (f.size > this.state.maxSize) {
					this.setState({ sizeError: true })
					continue
				}

				const thumb = await fileReader(f)

				prepared.push({
					id: `${f.name}-${f.size}-${f.lastModified}-${Math.random().toString(16).slice(2)}`,
					file: f,
					thumb,
					name: f.name,
					size: f.size,
					type: f.type
				})
			}

			setTimeout(() => {
				this.setState(
					prev => {
						const items = [...prev.items, ...prepared]
						return { items, isLoading: false }
					},
					() => {
						// Formik: tableau de File
						const filesArray = this.state.items.map(i => i.file)
						setFieldValue(fieldName, filesArray.length ? filesArray : null)

						// reset input (permet de re-sélectionner les mêmes fichiers)
						this.inputRef.current.value = ''

						if (prepared.length) this.props.onUpload()
					}
				)
			}, this.state.timeOutSimulation ? 1000 : 0)
		} catch (err) {
			this.inputRef.current.value = ''
			setFieldValue(fieldName, null)
			this.setState({ isLoading: false, loadingError: true })
		}
	}

	handleRemoveItem(itemId, fieldName, setFieldValue, setFieldTouched) {
		this.setState(
			prev => ({ items: prev.items.filter(i => i.id !== itemId) }),
			() => {
				const filesArray = this.state.items.map(i => i.file)
				setFieldValue(fieldName, filesArray.length ? filesArray : null)
				setFieldTouched(fieldName, filesArray.length > 0)

				if (!filesArray.length) this.props.onUnload()
			}
		)
	}

	// reset complet depuis l'extérieur si besoin: this.MultipleFileUpload.destroy(...)
	destroy(fieldName, setFieldValue, setFieldTouched) {
		this.inputRef.current.value = ''
		this.setState(
			{
				items: [],
				previewThumb: undefined,
				previewThumbName: undefined,
				sizeError: false,
				formatError: false,
				loadingError: false
			},
			() => {
				if (fieldName && setFieldValue) setFieldValue(fieldName, null)
				if (fieldName && setFieldTouched) setFieldTouched(fieldName, false)
				this.props.onUnload()
			}
		)
	}

	openPreview(item) {
		if (!isImage(item.type)) return
		this.setState(
			{ previewThumb: item.thumb, previewThumbName: item.name },
			() => this.MultipleFileUploadModal?.openModal()
		)
	}

	render() {
		const { setFieldValue, setFieldTouched, errors, touched, fieldName } = this.props
		const {
			isLoading,
			items,
			maxSize,
			sizeError,
			sizeErrorText,
			formatError,
			formatErrorText,
			loadingError,
			loadingErrorText,
			labelText,
			ctaCancelText,
			thumbSizeW,
			thumbSizeH,
			acceptedFormatsText
		} = this.state

		return (
			<div className={`ctn_multiple-file-upload${this.state.isHover ? ' hover' : ''}`}>
				<div className={errors[fieldName] && touched[fieldName] ? 'error' : ''}>
					<div className="obj_file-upload">
						<div className="i_picto">
							<IconSVG icon="i_file_upload" />	
						</div>
						<h4 className="t_title">Importer un listing</h4>
						<p className="t_formats">{acceptedFormatsText}</p>
						<div className="ctn_btn" onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
							<label className="obj_btn" htmlFor={fieldName}>
								{labelText}
							</label>
						</div>
					</div>
				</div>

				<input
					ref={this.inputRef}
					type="file"
					id={fieldName}
					name={fieldName}
					multiple
					accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.csv"
					onChange={(e) => this.handleFileChange(e, fieldName, setFieldValue)}
				/>

				

				{loadingError && <p className="t_error fade-in">{loadingErrorText}</p>}
				{formatError && <p className="t_error fade-in">{formatErrorText}</p>}
				{sizeError && <p className="t_error fade-in">{sizeErrorText} {bytesToMegabytes(maxSize)} Mo.</p>}
				{isLoading && <div className="obj_loader fade-in"></div>}

				{!!items.length && (
					<div className="list_file-thumbs">
						{items.map(item => (
							<div className="ctn_file-thumb fade-in" key={item.id}>
								{/* thumb (image si possible, sinon defaultThumb) */}
								<div
									className={`canvas_thumb${isImage(item.type) ? '' : ' no_cursor'}`}
									onClick={() => this.openPreview(item)}
									style={{
										width: thumbSizeW,
										height: thumbSizeH,
										backgroundSize: 'cover',
										backgroundPosition: 'center',
										backgroundImage: `url(${isImage(item.type) ? item.thumb : this.state.defaultThumb})`
									}}
								/>

								<div className="ctn_infos">
									<p className="t_name">{item.name}</p>
									<p className="t_weight">{bytesToMegabytes(item.size)} Mo</p>
								</div>
								<button
									className="bt_cancel"
									type="button"
									onClick={() => this.handleRemoveItem(item.id, fieldName, setFieldValue, setFieldTouched)}
								>
									{ctaCancelText}
								</button>
							</div>
						))}

						{/* Modal preview (réutilise ton composant existant) */}
						<SingleFileUploadModal
							onRef={ref => (this.MultipleFileUploadModal = ref)}
							previewThumb={this.state.previewThumb}
							previewThumbName={this.state.previewThumbName}
						/>
					</div>
				)}
			</div>
		)
	}
}

MultipleFileUpload.defaultProps = {
	onUpload: () => {},
	onUnload: () => {},
	onRef: () => {}
}

export default MultipleFileUpload